import React from "react";

import type { NavigateFromOptions } from "./core";
import { useNavigateFromLink } from "./hooks";
import { Link, type LinkProps } from "./Link";

export interface LinkFromProps<TRoute extends string> extends Omit<LinkProps, "to">, NavigateFromOptions<TRoute> {
	from: "*" | TRoute | Array<TRoute>;
}

/**
 * A link component that navigates from the given route.
 * If none of the given routes is active, the link is not rendered.
 *
 * @see useNavigateFromLink
 */
export const LinkFrom: <TRoute extends string>(
	props: React.RefAttributes<HTMLAnchorElement> & LinkFromProps<TRoute>,
) => React.ReactNode = React.forwardRef(({ from, params, search, ...props }, ref) => {
	const link = useNavigateFromLink(from, { params, search });

	if (link == null) {
		return null;
	}

	return <Link ref={ref} to={link} {...props} />;
});
